// Mirrors api/src/terms.ts TERMS_VERSION. The onboarding gate records acceptance
// of this exact version; bump in lockstep with the API when the Terms change.
export const TERMS_VERSION = "2026-06-11";

export const LEGAL_TERMS_URL = "https://portal.cogent.tools/terms";
export const LEGAL_PRIVACY_URL = "https://portal.cogent.tools/privacy";

// The distributed "Add to Slack" install surface lives on the API origin (Slack OAuth
// — GET /slack/install → Slack authorize). Required step before /cogent works in a
// workspace; the onboarding guide links here.
export const SLACK_INSTALL_URL = "https://app.cogent.tools/slack/install";

// Step-by-step how-to (install the plugin, register with ORGID, /cogent map, keeping
// the plugin updated). Hosted on the marketing site (cogent.tools/how-to) — the portal
// SPA has no /how-to route, so it MUST point at the marketing host, not portal.* (a
// portal.* URL hits the SPA catch-all and redirects to /register). See COG-4.
export const HOWTO_URL = "https://cogent.tools/how-to";
